import { arrayOf, bool, element, eventListener, expression, number, object, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const FieldListProperties = {
    addFieldExpression: {
        defaultValue: 'tws.field-list.add-another',
        type: expression,
    },
    children: {
        type: oneOfType([arrayOf(element), element]),
    },
    className: {
        type: string,
    },
    enabled: {
        defaultValue: true,
        type: bool,
    },
    labelKey: {
        defaultValue: 'value',
        type: string,
    },
    maxRows: {
        defaultValue: Infinity,
        type: number,
    },
    onBlur: {
        type: eventListener,
    },
    onChange: {
        type: eventListener,
    },
    previewAmount: {
        defaultValue: 1,
        type: number,
    },
    readOnly: {
        type: bool,
    },
    removeFieldExpression: {
        defaultValue: 'tws.field-list.remove',
        type: expression,
    },
    showAddField: {
        defaultValue: true,
        type: bool,
    },
    showRemoveField: {
        defaultValue: true,
        type: bool,
    },
    uuid: {
        defaultValue: '',
        type: string,
    },
    value: {
        defaultValue: [{}],
        type: arrayOf(object),
    },
};
export { FieldListProperties, };
//# sourceMappingURL=field-list-types.js.map